export var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType["COLLECTION"] = "collection";
    TreeNodeType["MANIFEST"] = "manifest";
    TreeNodeType["RANGE"] = "range";
})(TreeNodeType || (TreeNodeType = {}));
//# sourceMappingURL=TreeNodeType.js.map